import Vue from 'vue'
import VueRouter from 'vue-router'

// K线相关
import StockKLineView from '@/views/kline/StockKLineView.vue'
import StockKLineWeekView from '@/views/kline/StockKLineWeekView.vue'
import StockKLine5MinView from '@/views/kline/StockKLine5MinView.vue'
import StockKLine5DayView from '@/views/kline/StockKLine5DayView.vue'

// 技术指标
import StockMACDView from '@/views/indicators/StockMACDView.vue'
import StockRSIView from '@/views/indicators/StockRSIView.vue'
import StockMomentumView from '@/views/indicators/StockMomentumView.vue'
import StockKDJView from '@/views/indicators/StockKDJView.vue'
import StockBollingerView from '@/views/indicators/StockBollingerView.vue'
import StockOBVView from '@/views/indicators/StockOBVView.vue'
import StockVPTView from '@/views/indicators/StockVPTView.vue'
import StockADView from '@/views/indicators/StockADView.vue'
import StockMFIView from '@/views/indicators/StockMFIView.vue'

// 智能筛选
import StockIndustryView from '@/views/screening/StockIndustryView.vue'
import StockTrendQueryView from '@/views/screening/StockTrendQueryView.vue'
import StockMomentumListView from '@/views/screening/StockMomentumListView.vue'
import StockTrendListView from '@/views/screening/StockTrendListView.vue'
import StockCustomQueryView from '@/views/screening/StockCustomQueryView.vue'
import StockSectorQueryView from '@/views/screening/StockSectorQueryView.vue'
import OversoldView from '@/views/screening/OversoldView.vue'

// 量化交易
import BacktestBollingerView from '@/views/quant-trading/BacktestBollingerView.vue'
import BacktestBollingerOptimizeView from '@/views/quant-trading/BacktestBollingerOptimizeView.vue'
import BacktestMACDView from '@/views/quant-trading/BacktestMACDView.vue'
import BacktestMACDOptimizeView from '@/views/quant-trading/BacktestMACDOptimizeView.vue'

// 自选股票
import StockFavoriteView from '@/views/favorite/StockFavoriteView.vue'

// 实时行情
import RealtimeQuoteView from '@/views/quote/RealtimeQuoteView.vue'

// 冰山订单检测
import IcebergDetectionView from '@/views/iceberg/IcebergDetectionView.vue'
import IcebergMinuteView from '@/views/iceberg/IcebergMinuteView.vue'

// 资金流向分析
import BillFlowView from '@/views/bill/BillFlowView.vue'
import BillFlowMinuteView from '@/views/bill/BillFlowMinuteView.vue'
import BillTickView from '@/views/bill/BillTickView.vue'

// 系统管理
import ScheduledTasksView from '@/views/system/ScheduledTasksView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/kline/day'
  },
  // K线分析
  {
    path: '/kline/day',
    name: 'StockKLineDay',
    component: StockKLineView
  },
  {
    path: '/kline/week',
    name: 'StockKLineWeek',
    component: StockKLineWeekView
  },
  {
    path: '/kline/5min',
    name: 'StockKLine5Min',
    component: StockKLine5MinView
  },
  {
    path: '/kline/5day',
    name: 'StockKLine5Day',
    component: StockKLine5DayView
  },
  // 技术指标
  {
    path: '/macd',
    name: 'StockMACD',
    component: StockMACDView
  },
  {
    path: '/rsi',
    name: 'StockRSI',
    component: StockRSIView
  },
  {
    path: '/momentum',
    name: 'StockMomentum',
    component: StockMomentumView
  },
  {
    path: '/kdj',
    name: 'StockKDJ',
    component: StockKDJView
  },
  {
    path: '/bollinger',
    name: 'StockBollinger',
    component: StockBollingerView
  },
  {
    path: '/obv',
    name: 'StockOBV',
    component: StockOBVView
  },
  {
    path: '/vpt',
    name: 'StockVPT',
    component: StockVPTView
  },
  {
    path: '/ad',
    name: 'StockAD',
    component: StockADView
  },
  {
    path: '/mfi',
    name: 'StockMFI',
    component: StockMFIView
  },
  // 智能筛选
  {
    path: '/industry',
    name: 'StockIndustry',
    component: StockIndustryView
  },
  {
    path: '/trend',
    name: 'StockTrendQuery',
    component: StockTrendQueryView
  },
  {
    path: '/momentum-list',
    name: 'StockMomentumList',
    component: StockMomentumListView
  },
  {
    path: '/trend-list',
    name: 'StockTrendList',
    component: StockTrendListView
  },
  {
    path: '/custom-query',
    name: 'StockCustomQuery',
    component: StockCustomQueryView
  },
  {
    path: '/sector',
    name: 'StockSectorQuery',
    component: StockSectorQueryView
  },
  {
    path: '/mfi-oversold',
    name: 'Oversold',
    component: OversoldView
  },
  // 量化交易
  {
    path: '/backtest',
    name: 'BacktestBollinger',
    component: BacktestBollingerView
  },
  {
    path: '/optimize',
    name: 'BacktestBollingerOptimize',
    component: BacktestBollingerOptimizeView
  },
  {
    path: '/macd-backtest',
    name: 'BacktestMACD',
    component: BacktestMACDView
  },
  {
    path: '/macd-optimize',
    name: 'BacktestMACDOptimize',
    component: BacktestMACDOptimizeView
  },
  // 自选股票
  {
    path: '/favorite',
    name: 'StockFavorite',
    component: StockFavoriteView
  },
  // 实时行情
  {
    path: '/realtime-quote',
    name: 'RealtimeQuote',
    component: RealtimeQuoteView
  },
  // 冰山订单检测
  {
    path: '/iceberg',
    name: 'IcebergDetection',
    component: IcebergDetectionView
  },
  {
    path: '/iceberg-minute',
    name: 'IcebergMinute',
    component: IcebergMinuteView
  },
  // 资金流向分析
  {
    path: '/bill/day',
    name: 'BillFlowDay',
    component: BillFlowView
  },
  {
    path: '/bill/minute',
    name: 'BillFlowMinute',
    component: BillFlowMinuteView
  },
  {
    path: '/bill/tick',
    name: 'BillTick',
    component: BillTickView
  },
  // 系统管理
  {
    path: '/scheduled-tasks',
    name: 'ScheduledTasks',
    component: ScheduledTasksView
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
